import { alpha } from '@mui/system/colorManipulator';
import { common } from '@mui/material/colors';
import { error, info, neutral, success, warning } from '../colors';
import { getPrimary } from '../utils';

export const createPalette = (config) => {
  const { colorPreset, contrast } = config;
  const primary = getPrimary(colorPreset);

  return {
    action: {
      active: '#636363',
      disabled: alpha('#141414', 0.38),
      disabledBackground: alpha('#141414', 0.12),
      focus: alpha(primary.main, 0.16),
      hover: alpha(primary.main, 0.05),
      selected: alpha(primary.main, 0.12),
    },
    background: {
      default: contrast === 'high' ? '#F5F7FA' : '#FAFBFC',
      paper: common.white,
    },
    divider: '#E1E8F0',
    error,
    info,
    mode: 'light',
    neutral,
    primary,
    success,
    text: {
      primary: '#141414',
      secondary: '#494949',
      disabled: alpha('#141414', 0.38),
    },
    warning,
  };
};
